<template>
  <div>
    <p class="mt-4" ref="title">
      <b>{{ name }}</b>
    </p>

    <v-list two-line>
      <v-list-tile v-for="(item, index) in value" :key="index">
        <v-list-tile-content
          @click="showPane(item, index)"
          style="cursor: pointer"
        >
          <v-list-tile-title>{{
            getItemById(item.id).label
          }}</v-list-tile-title>
          <v-list-tile-sub-title
            >ICD10: {{ getItemById(item.id).icd10 }}</v-list-tile-sub-title
          >
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="removeItem(item)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile
        v-if="!showEditorPane && !(singleSelect && value.length > 0)"
      >
        <v-list-tile-content>
          <v-list-tile-title @click="showPane()" style="cursor: pointer"
            >Adicionar</v-list-tile-title
          >
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="showPane()">
            <v-icon color="primary">add_circle</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <div v-if="showEditorPane">
      <v-tabs slider-color="primary" v-model="activeTab">
        <v-tab :key="0">{{ $t('common.Search') }}</v-tab>
        <v-tab :key="1">{{ $tc('common.Tree') }}</v-tab>
        <v-tab-item>
          <v-autocomplete
            :return-object="true"
            :items="procedures"
            label="Procedimento"
            item-text="label"
            item-value="id"
            v-model="procedure"
            @input="selectItem(procedure)"
          />
        </v-tab-item>
        <v-tab-item>
          <v-treeview
            :items="optionsTree"
            item-text="label"
            :open="treeOpen"
            dense
          >
            <template v-slot:prepend="{ item }">
              <v-icon
                v-if="!item.children && selectedItem.id !== item.id"
                @click="selectItem(item)"
                >radio_button_unchecked</v-icon
              >
              <v-icon
                v-if="
                  !item.children &&
                    selectedItem.id &&
                    selectedItem.id === item.id
                "
                @click="selectItem(null)"
                >radio_button_checked</v-icon
              >
            </template>
            <template v-slot:label="{ item }">
              <span @click="!item.children ? selectItem(item) : null">{{
                item.label
              }}</span>
            </template>
          </v-treeview>
        </v-tab-item>
      </v-tabs>
      <v-layout wrap>
        <v-flex xs12 md8>
          <v-text-field
            color="primary"
            :label="singularName"
            disabled
            :value="selectedItem.label"
            class="mr-1"
          />
        </v-flex>
        <v-flex xs12 md4 ref="selectedItemView">
          <v-text-field
            color="primary"
            label="ICD10"
            disabled
            :value="selectedItem.icd10"
            class="mr-1"
          >
            <template v-slot:append v-if="selectedItem.icd10">
              <v-icon v-if="selectedItem.complete" color="primary"
                >checkbox</v-icon
              >
              <v-icon v-else color="black">help</v-icon>
              <!-- hint explaining why the icd code isn't complete -->
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout class="ma-2">
        <v-btn
          small
          :disabled="!selectedItem.id"
          @click.prevent="editItem()"
          v-if="paneIndex !== null"
          >Editar</v-btn
        >
        <v-btn
          small
          :disabled="!selectedItem.id"
          @click.prevent="addItem()"
          v-else
          >Adicionar</v-btn
        >
        <v-btn
          small
          color="#fb9db8"
          depressed
          @click.prevent="showEditorPane = false"
          >Cancelar</v-btn
        >
      </v-layout>
    </div>
  </div>
</template>

<script>
import {
  TraumaProcedure,
  OrthopedicProcedure,
  AnatomicRegion
} from '@/models/Orthopedics'

export default {
  props: {
    value: { type: Array, default: () => [] },
    singularName: { type: String, default: '' },
    name: { type: String, default: '' },
    singleSelect: { type: Boolean, default: false },
    typeOfSurgery: { type: String },
    anatomicRegion: { type: String }
  },
  data() {
    return {
      selectedItem: {},
      treeOpen: [],
      activeTab: '0',
      showEditorPane: false,
      paneIndex: null,
      procedure: null
    }
  },
  computed: {
    procedures() {
      return this.typeOfSurgery === 'trauma'
        ? TraumaProcedure.query().get()
        : OrthopedicProcedure.query().get()
    },
    optionsTree() {
      const anatomicRegionsQuery = AnatomicRegion.query()

      if (this.anatomicRegion) {
        anatomicRegionsQuery.whereIdIn([this.anatomicRegion, 'other'])
      }

      const anatomicRegions = anatomicRegionsQuery.get()

      return anatomicRegions.map(ar => ({
        ...ar,
        children: this.procedures.filter(d => d.regionIds.includes(ar.id))
      }))
    }
  },
  watch: {},
  methods: {
    showPane(item = null, index = null) {
      if (item) {
        this.selectedItem = this.getItemById(item.id)

        this.paneIndex = index
      } else {
        this.selectedItem = {}
        this.paneIndex = null
      }
      this.showEditorPane = true
      if (this.$vuetify.breakpoint.xs) {
        this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      }
    },
    emitUpdate(newItems) {
      this.$emit('input', newItems)
    },
    addItem() {
      if (this.selectedItem.id) {
        this.emitUpdate([
          ...this.value,
          {
            id: this.selectedItem.id
          }
        ])
        this.showEditorPane = false
      }
    },
    editItem() {
      let newItems = [...this.value]
      newItems[this.paneIndex] = {
        id: this.selectedItem.id
      }
      // verificar
      this.emitUpdate(newItems)
      this.showEditorPane = false
    },
    removeItem(item) {
      if (this.paneIndex !== null) {
        this.paneIndex = null
        this.showEditorPane = false
      }
      this.emitUpdate(this.value.filter(element => element !== item))
    },
    selectItem(target) {
      if (!target) {
        this.selectedItem = {}
        return
      }
      this.selectedItem = this.getItemById(target.id)
    },
    getItemById(targetId) {
      let treeItem = TraumaProcedure.find(targetId)
      treeItem = treeItem ? treeItem : OrthopedicProcedure.find(targetId)
      return treeItem
    }
  }
}
</script>

